import React, { useState } from 'react';
import SummaryRhs from '../../../../dynamic/components/top-bar/js/rhs-header';
import DeveloperGuides from '../../../../dynamic/components/top-bar/js/developer-guides';
import LifeCycle from '../../../../dynamic/components/chip/js/life-cycle';
import SeeOverview from '../../../../dynamic/components/top-bar/js/see-overview';


class RHSHeader extends React.Component
{
    render(){
        return(         
            <div id ="headerExample">		
				<SummaryRhs/>
				<LifeCycle/>
				<SeeOverview/>
				<DeveloperGuides/>
			</div>
            )};
}

export default RHSHeader;